import {isUndefined} from 'lodash';
// eslint-disable-next-line import/no-cycle
import WidgetSettingFormField from './WidgetSettingFormField';

export class BaseWidgetConfig {
  rootStore;
  settingsIdentifier;
  storeData;

  constructor(rootStore, widgetIdentifier, storeData = undefined) {
    this.rootStore = rootStore;
    this.settingsIdentifier = `${widgetIdentifier}.settings`;
    this.storeData = storeData || (() => this.rootStore.settingStore.getByIdentifier(this.settingsIdentifier));
  }

  static onLoadConfig = () => {
    // load dependencies for BaseWidgetConfig
  };

  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [];
  }

  // eslint-disable-next-line class-methods-use-this
  mapSettingPropertyKeyToProperty(localSetting, key) {
    let value = key;
    let settings = localSetting.properties;
    if (localSetting.type === WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField) {
      value = key?.property;
      settings = localSetting.modelOptions;
    }
    let result = settings?.find((property) => property.key === value);
    result = {...result};
    if (Object.keys(result).length === 0) {
      // eslint-disable-next-line no-console
      console.warn(`Property "${key}" is unknown`);
      return undefined;
    }
    if (!isUndefined(result)
      && localSetting.type === WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField
      && key.label
    ) {
      result.label = key.label;
      result.title = key.label;
    }
    return result;
  }

  getSelectedProperties(tab, identifier) {
    const localSetting = this[tab]?.find((setting) => setting.id === identifier);
    if (localSetting) {
      return this.getSettingValue(tab, identifier)
        .map((propertyKey) => this.mapSettingPropertyKeyToProperty(localSetting, propertyKey))
        .filter((item) => item !== undefined);
    }

    return [];
  }

  getSettingValueForSource(identifier) {
    // This is the case if the Source is the SettingStore
    if (this.storeData()?.value) {
      return this.storeData()?.value[identifier];
    }

    // This is the case if the Source is either the config property of the cockpitWidget or another property
    // on the entity (e.g name of cockpitWidget)
    const configProperty = this.storeData()?.config && JSON.parse(this.storeData()?.config);
    return configProperty?.[identifier] ?? this.storeData()?.[identifier];
  }

  getSettingValue(tab, identifier) {
    const localSetting = this[tab]?.find((setting) => setting.id === identifier);
    if (!localSetting) {
      return undefined;
    }
    const remoteSettingValue = this.getSettingValueForSource(identifier);

    let value;
    if (remoteSettingValue) {
      value = remoteSettingValue;
    } else if (localSetting?.type === WidgetSettingFormField.fieldTypes.Number) {
      value = remoteSettingValue ?? localSetting?.defaultValue;
    } else if (localSetting?.type === WidgetSettingFormField.fieldTypes.Boolean) {
      value = isUndefined(remoteSettingValue) ? localSetting?.defaultValue : remoteSettingValue;
    } else if (localSetting?.type === WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField) {
      value = isUndefined(remoteSettingValue) ? localSetting?.defaultValue : remoteSettingValue;
    } else {
      value = localSetting?.defaultValue;
    }
    switch (localSetting.type) {
      case (WidgetSettingFormField.fieldTypes.Number):
        if (value && typeof value === 'string') {
          return Number(value);
        }
        if (!value && typeof value !== 'number') {
          return null;
        }
        return value;
      case (WidgetSettingFormField.fieldTypes.Boolean):
        return Boolean(value);
      case (WidgetSettingFormField.fieldTypes.Properties):
        return value;
      case WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField: {
        const propertiesSelectDisplayFieldList = [];
        value = Array.isArray(value) ? value : [];
        // Iterate over properties to handle different version and setting defaults where required
        for (let index = 0; index < value.length; index += 1) {
          const element = value[index];
          let tempValue;
          let option;

          if (typeof element === 'string') {
            // Upgrade from old settings
            option = localSetting.modelOptions.find((x) => x.key === element);
            tempValue = option ? {
              property: element,
              label: (option?.title || option?.label),
            } : null;
          } else {
            // Handle new format and set default label if necessary
            tempValue = {...element};
            if (!tempValue.label) {
              option = localSetting.modelOptions.find((x) => x.key === element.property);
              tempValue.label = option?.title || option?.label;
            }
          }
          // Add new element to result list
          propertiesSelectDisplayFieldList.push(tempValue);
        }
        return propertiesSelectDisplayFieldList;
      }
      default:
        return value;
    }
  }

  getValues() {
    const values = {};
    this.tabs.forEach((tab) => {
      this[tab.key].forEach((localSetting) => {
        values[localSetting.id] = this.getSettingValue(tab.key, localSetting.id);
      });
    });

    return values;
  }
}
